export default [{
    name: '1 hour',
    value: '8'
}, {
    name: '24 hours',
    value: '180'
}, {
    name: '7 days',
    value: '1440'
}];
